var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { fetchDepartureLocale } from '../services/SearchDestinationsService';
import { useSearch } from '../contexts/InputSearchContext';
import { useCalendar } from '../contexts/CalendarContext';
import ApiServices from '../config/axiosConfig';
export function useLocationSearch({ setFieldValue }) {
    const { handleDestinationClick } = useSearch();
    const { showDateModal } = useCalendar();
    const [departureOptions, setDepartureOptions] = useState([]);
    const [destinationOptions, setDestinationOptions] = useState([]);
    const [isDepartureLoading, setIsDepartureLoading] = useState(false);
    const [isDestinationLoading, setIsDestinationLoading] = useState(false);
    const [dropdownOpenDeparture, setDropdownOpenDeparture] = useState(false);
    const [dropdownOpenDestination, setDropdownOpenDestination] = useState(false);
    const apiService = ApiServices();
    const handleDepartureSearch = (value) => __awaiter(this, void 0, void 0, function* () {
        if (value.length >= 3) {
            setIsDepartureLoading(true);
            setDropdownOpenDeparture(true);
            try {
                const options = yield fetchDepartureLocale({ query: value, apiService });
                const sortedOptions = options
                    .map((option) => ({
                    label: option.nmAeroporto || option.nmHotel || option.sbRegiao,
                    value: option.id,
                    id: option.id,
                    nmRegiao: option.nmRegiao,
                    cdLatitude: option.cdLatitude,
                    cdLongitude: option.cdLongitude,
                    tpDestino: option.tpDestino,
                    sgIata: option === null || option === void 0 ? void 0 : option.sgIata,
                    destinType: option.destinType,
                }))
                    .sort((a, b) => {
                    if (a.sgIata && b.sgIata) {
                        return a.sgIata.toLowerCase().startsWith(value.toLowerCase())
                            ? -1
                            : 1;
                    }
                    if (a.sgIata)
                        return -1;
                    if (b.sgIata)
                        return 1;
                    return 0;
                });
                setDepartureOptions(sortedOptions);
            }
            catch (error) {
                console.error('Erro ao buscar partidas:', error);
            }
            finally {
                setDropdownOpenDeparture(true);
                setIsDepartureLoading(false);
            }
        }
        else {
            setDepartureOptions([]);
        }
    });
    const handleDestinationSearch = (value) => __awaiter(this, void 0, void 0, function* () {
        if (value.length >= 3) {
            setIsDestinationLoading(true);
            try {
                const options = yield fetchDepartureLocale({ query: value, apiService });
                const sortedOptions = options
                    .map((option) => ({
                    label: option.nmAeroporto || option.nmHotel || option.sbRegiao,
                    value: option.id,
                    id: option.id,
                    nmRegiao: option.nmRegiao,
                    cdLatitude: option.cdLatitude,
                    cdLongitude: option.cdLongitude,
                    tpDestino: option.tpDestino,
                    sgIata: option.sgIata,
                    destinType: option.destinType,
                }))
                    .sort((a, b) => {
                    if (a.sgIata && b.sgIata) {
                        return a.sgIata.toLowerCase().startsWith(value.toLowerCase())
                            ? -1
                            : 1;
                    }
                    if (a.sgIata)
                        return -1;
                    if (b.sgIata)
                        return 1;
                    return 0;
                });
                setDestinationOptions(sortedOptions);
            }
            catch (error) {
                console.error('Erro ao buscar destinos:', error);
            }
            finally {
                setIsDestinationLoading(false);
                setDropdownOpenDestination(true);
            }
        }
        else {
            setDestinationOptions([]);
        }
    });
    const handleSelectDeparture = (selectedOption) => {
        setDropdownOpenDeparture(false);
        const origin = Object.assign(Object.assign({}, selectedOption), { origin: selectedOption.tpDestino === 'A'
                ? selectedOption.sgIata
                : selectedOption.id, originIata: selectedOption.sgIata });
        setFieldValue('departure', origin);
        handleDestinationClick();
        return origin;
    };
    const handleSelectDestination = (selectedOption) => {
        setDropdownOpenDestination(false);
        const destination = Object.assign(Object.assign({}, selectedOption), { destin: selectedOption.tpDestino === 'A'
                ? selectedOption.sgIata
                : selectedOption.id, destinType: selectedOption.destinType });
        setFieldValue('destination', destination);
        showDateModal();
        return destination;
    };
    return {
        departureOptions,
        destinationOptions,
        isDepartureLoading,
        isDestinationLoading,
        dropdownOpenDeparture,
        dropdownOpenDestination,
        handleDepartureSearch,
        handleDestinationSearch,
        handleSelectDeparture,
        handleSelectDestination,
        setDropdownOpenDeparture,
        setDropdownOpenDestination,
    };
}
//# sourceMappingURL=useLocationSearch.js.map